module.exports = "<div class=\"barcodes-top\">\n  <span class=\"barcodes-right\" *ngFor=\"let code of barcodes\">\n    <img id=\"barcode-{{code}}\"/>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/print-barcode/print-barcode.component.html
// module id = ../../../../../src/app/print-barcode/print-barcode.component.html
// module chunks = 1